import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PeriodService {
  private apiUrl = environment.apiUrl + '/period/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  private selectedPeriodId = new BehaviorSubject<string>(''); // Estado reactivo
  selectedPeriodId$ = this.selectedPeriodId.asObservable(); // Observable para escuchar cambios

  setselectedPeriodId(reportResponseId: string): void {
    this.selectedPeriodId.next(reportResponseId); // Actualiza el valor globalmente
  }
  getselectedPeriodId(): string {
    return this.selectedPeriodId.value; // Obtiene el valor actual
  }

  get(year?: number, isClosed?: Boolean): Observable<any> {
    let params = new HttpParams();
    if (year) params = params.set('year', year.toString());
    if (isClosed) params = params.set('isClosed', isClosed.toString())
    return this.http.get(`${this.apiUrl}get`, { params });
  }

  getView(year?: number, isClosed?: Boolean): Observable<any> {
    let params = new HttpParams();
    if (year) params = params.set('year', year.toString());
    if (isClosed) params = params.set('isClosed', isClosed.toString())
    return this.http.get(`${this.apiUrl}getView`, { params });
  }
  getById(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl + 'get/' + id)
  }
  update(id: string, userData: any): Observable<any> {
    console.log(userData)
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }
  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }

  saveWithVariables(periodData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}saveWithVariables`, periodData);
  }

  updateWithVariables(id: string, periodData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}updateWithVariables/${id}`, periodData);
  }

  getLastPeriod(): Observable<any> {
    return this.http.get(`${this.apiUrl}lastPeriod`);
  }
}

